export const md = {
  root: {
    width: '48px',
    height: '48px',
    padding: 1,
  },
};

export const lg = {
  root: {
    width: '72px',
    height: '72px',
    padding: 2,
  },
};

export const dimensionSelect = {
  root: {
    width: '72px',
    height: '60px',
    paddingX: 2,
    paddingY: '10px',
  },
};
